/**
 * Single source for the brand mark.
 *
 * The header had been pointing at the hosted Niyuk logo while every login /
 * password screen still imported the older bundled `logo.svg`, so the product
 * showed two different brands depending on whether you were signed in.
 */
export const BRAND_LOGO =
  "https://d7xkumgqnjpgr.cloudfront.net/company/3/signature/2026-04-08/logo.svg";

export const BRAND_NAME = "Niyuk";
